module.exports = __webpack_public_path__ + "img/logo-en.dbb7bc4c.png";